/**
 * External Dependencies
 */
import 'jquery';

import AOS from 'aos';

/**
 * App Scripts
 */

import menu from './menu';

import collaboration from './collaboration';

import panelToggle from './panelToggle';

import steps from './steps';

import scroll from './scroll';

import charts from './charts';

import modal from './modal';

import slider from './slider';

import video from './video';

$(document).ready(() => {

  AOS.init({
    disable: 'mobile',
    once: 'true',
  });
  
  if (document.getElementsByClassName('hamburger').length > 0) {
    menu();
  }

  if (document.body.classList.contains('our-leadership')) {
    collaboration();
  }

  if (document.getElementsByClassName('panelToggle').length > 0) {
    panelToggle();
  }

  if (document.getElementsByClassName('steps').length > 0) {
    steps();
  }

  if (document.getElementsByClassName('scroll').length > 0) {
    scroll();
  }

  if (document.getElementsByClassName('charts').length > 0) {
    charts();
  }

  if (document.getElementsByClassName('our-leadership').length > 0) {
    modal();
  }

  if (document.getElementsByClassName('popup-youtube').length > 0) {
    video();
  }

  if (document.getElementsByClassName('relationships-results').length > 0) {
    slider();
  }

  const handleContactBtn = () => {
    const btn = document.getElementById('contact-button');
    if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
      btn.classList.remove('opacity-0');
    } else {
      btn.classList.add('opacity-0');
    }
  };

  
  const handleFixedHeader = () => {
    const header = document.getElementById('site-header');
    if (document.body.scrollTop > 7 || document.documentElement.scrollTop > 7) {
      header.classList.add('is-active');
    } else {
      header.classList.remove('is-active');
    }
  };
  
    window.onscroll = function() {
      handleContactBtn();
      handleFixedHeader();
    };
});
